import { ComponentPropsWithoutRef } from 'react';
import { twMerge } from 'tailwind-merge';

const CmdSymbol = (props: ComponentPropsWithoutRef<'div'>) => {
    const { className = '', ...rest } = props;

    return (
        <div
            className={twMerge(
                'flex h-6 w-6 items-center justify-center rounded-md border border-gray-300 p-2 text-xs',
                className,
            )}
            {...rest}
        />
    );
};

export { CmdSymbol };
